import Vue from 'vue';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import fr from 'dayjs/locale/fr'

dayjs.locale(fr)
dayjs.extend(LocalizedFormat)

String.prototype.toDate = function () {
    return dayjs(this).format('L');
}

String.prototype.toDatetime = function () {
    return dayjs(this).format('YYMMDDHHmm');
}

String.prototype.toHour = function () {
    return dayjs(this).format('LT');
}

Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs
        }
    }
});
